import * as React from "react";
import "./index.css";
import { NavLink } from "react-router-dom";
import storageService from "../../../app/services/storageService";

const ChatTile = ({
  title,
  description,
  date,
  onClick,
  image,
  notificationCount,
  id,
}) => {
  const imageUrl = image || "/images/chat-tile-image.png";

  return (
    <NavLink to={`/messages/${id}`}>
      <section title={title} onClick={onClick} className="chat-tile-base">
        <div className="chat-tile-image-wrapper">
          <img src={`${storageService.publicUrl(image)}`} onError={(e) => {
            e.target.src = "https://i.imgur.com/6p9udbl.png"
            e.target.style.objectFit = "cover"
          }} alt={title} className="chat-tile-image" />
          <span className="notification-count">{notificationCount}</span>
        </div>
        <div className="chat-tile-info">
          <span className="chat-tile-title">{title}</span>
          <span className="chat-tile-description">{description}</span>
          <span className="chat-tile-date">
            {String(new Date(date).toUTCString())}
          </span>
        </div>
      </section>
    </NavLink>
  );
};

export default ChatTile;
